<template>
  <div class="account-open-container">
    <van-form @submit="onSubmit" scroll-to-error>
      <div class="form-info">
        <div class="form-item-common-container form-common-title form-bottom-line">
          基础信息
        </div>
        <van-field
          required
          v-model="form.corpName"
          maxlength="50"
          name="corpName"
          label="企业名称"
          placeholder="请输入企业名称，不能使用他人注册商标"
          :rules="[{ required: true }]"
        />
        <van-field
          required
          v-model="form.address"
          maxlength="256"
          name="address"
          label="企业地址"
          placeholder="请输入企业地址"
          :rules="[{ required: true }]"
        />
        <van-field
          required
          v-model="form.socialCreditCode"
          maxlength="18"
          name="socialCreditCode"
          label="统一社会信用码"
          placeholder="请输入统一社会信用码"
          :rules="[{ required: true }]"
        />
        <van-field
          required
          readonly
          clickable
          v-model="form.socialCreditCodeExpires"
          maxlength="256"
          name="socialCreditCodeExpires"
          label="统一社会信用代码终止日期"
          @click="showTime('0')"
          placeholder="请输入统一社会信用代码终止日期"
          :rules="[{ required: true }]"
          :disabled="socialEnterpriseRegion"
        />
        <van-cell center title="长期">
          <van-switch v-model="socialEnterpriseRegion" @change="changeTime" size="20" />
        </van-cell>
        <van-popup v-model="showPickerDatetime" position="bottom">
          <van-datetime-picker
            label="选择日期"
            type="date"
            :value="currentDate"
            @confirm="onInput"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="showPickerDatetime = false"
          />
        </van-popup>

        <van-field
          required
          v-model="form.businessScope"
          maxlength="200"
          type="textarea"
          name="businessScope"
          label="经营范围"
          placeholder="请输入经营范围"
          :rules="[{ required: true }]"
        />
        <div v-for="item in form.resourceList" :key="item.category">
          <van-field
            required
            v-if="item.category == 4"
            maxlength="50"
            name="resourceList"
            :rules="[
              {
                trigger: 'onSubmit',
                required: item.category != 7 && item.category != 8,
                message: '请上传照片',
              },
            ]"
          >
            <template #input>
              <open-live-upload-image
                :resource="item"
                @success="openLiveUploadSuccess"
                @delete="deleteOpenLiveUploadImage"
              ></open-live-upload-image>
            </template>
          </van-field>
        </div>
        <!-- warning -->
        <div class="form-item-common-container form-common-title form-bottom-line">
          法人信息
        </div>
        <van-field
          required
          v-model="form.legalPerson"
          maxlength="20"
          type="text"
          name="legalPerson"
          label="法人姓名"
          placeholder="请输入企业法人姓名"
          :rules="[{ required: true }]"
        />
        <van-field
          required
          v-model="form.legalCertId"
          maxlength="20"
          name="legalCertId"
          label="法人身份证号"
          placeholder="请输入企业法人身份证号"
          :rules="[{ required: true }]"
        />
        <van-field
          required
          readonly
          clickable
          v-model="form.legalCertIdExpires"
          maxlength="256"
          name="legalCertIdExpires"
          label="法人身份证终止日期"
          @click="showTime('1')"
          placeholder="请输入法人身份证终止日期"
          :rules="[{ required: true }]"
          :disabled="legalEnterpriseRegion"
        />
        <van-cell center title="长期">
          <van-switch v-model="legalEnterpriseRegion" @change="changelegeTime" size="20" />
        </van-cell>
        <van-field
          required
          v-model="form.phone"
          type="number"
          name="phone"
          label="法人手机号"
          placeholder="请输入法人手机号"
          :rules="[{ required: true }]"
        />
        <div v-for="item in form.resourceList" :key="item.category">
          <van-field
            required
            v-if="item.category == 5 || item.category == 6"
            maxlength="50"
            name="resourceList"
            :rules="[
              {
                trigger: 'onSubmit',
                required: item.category != 7 && item.category != 8,
                message: '请上传照片',
              },
            ]"
          >
            <template #input>
              <open-live-upload-image
                :resource="item"
                @success="openLiveUploadSuccess"
                @delete="deleteOpenLiveUploadImage"
              ></open-live-upload-image>
            </template>
          </van-field>
        </div>

        <div class="form-item-common-container form-common-title form-bottom-line">
          银行信息
        </div>
        <van-field
          required
          v-model="form.corpName"
          type="text"
          name="corpName"
          maxlength="64"
          label="银行开户名"
          placeholder="不可输入同公司名"
          disabled="true"
        />
        <van-field
          required
          readonly
          clickable
          name="bankId"
          :value="bankName"
          label="开户银行"
          placeholder="请点击选择开户银行"
          @click="showBankList = true"
          :rules="[{ required: true }]"
        />
        <van-field
          readonly
          required
          clickable
          name="showAreaText"
          :value="showAreaText"
          label="开户行所在地"
          placeholder="请点击选择开户行所在地"
          @click="showAddressList = true"
          :rules="[{ required: true }]"
        />
        <van-field
          required
          v-model="form.bankAcctNum"
          maxlength="256"
          name="bankAcctNum"
          label="企业对公账户"
          placeholder="请输入企业对公账户"
          :rules="[{ required: true }]"
        />
        <div v-for="item in form.resourceList" :key="item.category">
          <van-field
            required
            v-if="item.category == 7"
            maxlength="50"
            name="resourceList"
            :rules="[
              {
                trigger: 'onSubmit',
                required: item.category != 8,
                message: '请上传照片',
              },
            ]"
          >
            <template #input>
              <open-live-upload-image
                :resource="item"
                @success="openLiveUploadSuccess"
                @delete="deleteOpenLiveUploadImage"
              ></open-live-upload-image>
            </template>
          </van-field>
        </div>
        <div class="form-bottom">
          <van-button type="primary" color="#0B6CE3" block native-type="submit"
            >立即开通</van-button
          >
        </div>
      </div>
    </van-form>
    <van-popup v-model="showBankList" position="bottom">
      <div class="top-tool-bar">
        <div class="cancel" @click="onCancelBank">取消</div>
        <div class="confirm" @click="onConfirmBank">确定</div>
      </div>
      <van-search
        v-model="searchBankWorld"
        placeholder="请输入搜索开户行"
        @search="onBankSearch"
        @cancel="onBankSearchCancel"
      />
      <div class="tip">如果列表中没有您的的开户银行，请选择搜索</div>
      <van-picker :columns="bankShowList" value-key="name" ref="bankPick" />
    </van-popup>
    <van-popup v-model="showAddressList" position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"
        value-key="name"
        @change="areaSelectChanged"
        @confirm="onAreaConfirm"
        @cancel="showAddressList = false"
      />
    </van-popup>
  </div>
</template>

<script>
import openLiveUploadImage from '@/views/components/openLiveUploadImage';
import {
  bankList,
  provinceList,
  cityList,
  accountCreate,
  getAccountView,
  accountUpdate,
  getQiniuInfos,
} from '@/api/capital';
import { formatDate } from '@/utils/index';
import { createzip } from '@/utils/createZip';
import { Toast } from 'vant';

export default {
  components: { openLiveUploadImage },
  props: {
    submitInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      readOnly: true,
      userParam: [],
      isShow: false,
      showBankList: false, // 开户银行
      showAddressList: false,
      formBtns: [],
      areaList: [{ values: [] }, { values: [] }],
      isProvince: true,
      county: true,
      city: true,
      initList: {
        province_list: {},
        county_list: {},
        city_list: {},
      },
      uid: null,
      user: null,
      bankName: '',
      showAreaText: '',
      searchBankWorld: '', // 搜索银行关键字
      allBankList: [],
      socialEnterpriseRegion: false,
      legalEnterpriseRegion: false,
      form: {
        bankAcctUrl: '',
        bankAcctName: '',
        bankAcctNum: '',
        phone: '',
        bankAreacode: [],
        socialCreditCodeExpires: '',
        corpName: '', //企业名称
        address: '', //企业地址
        socialCreditCode: '', //社会统一信用吗
        businessScope: '', //经营范围
        legalPerson: '', //法人姓名
        legalCertId: '', //法人身份证
        legalCertIdExpires: '', //截止日期
        shopType: '1',
        resourceList: [
          {
            category: 4, ////类别： 1-身份证正面 2-身份证反面 3-手持身份证 4-营业执照副本 5-法人身份证正面 6-法人身份证反面 7-食品经营许可 8-拍卖经营许可
            imageHeight: 0,
            imageUrl: '',
            imageWidth: 0,
          },
          {
            category: 5,
            imageHeight: 0,
            imageUrl: '',
            imageWidth: 0,
          },
          {
            category: 6,
            imageHeight: 0,
            imageUrl: '',
            imageWidth: 0,
          },
          {
            category: 7,
            imageHeight: 0,
            imageUrl: '',
            imageWidth: 0,
          },
        ],
      },
      currentDate: new Date(),
      showPickerDatetime: false,
      minDate: new Date(1970, 1, 1),
      maxDate: new Date(3000, 1, 1),
      isShowTime: '',
      status: '',
    };
  },
  watch: {
    submitInfo: {
      handler(value) {
        if (value && value.id) {
          for (const key in this.form) {
            if (Object.hasOwnProperty.call(this.form, key)) {
              const keyValue = value[key];
              // resourceList  会掺杂 企业店铺 的 图片，所以需要筛掉
              if (key == 'resourceList' && keyValue instanceof Array) {
                this.form.resourceList = this.form.resourceList.map((item, index) => {
                  const resource = keyValue.find(imageData => imageData.category === item.category);
                  return resource || item;
                });
              } else if (keyValue) {
                this.form[key] = keyValue;
              }
            }
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.status = this.$route.params.id;
    this.init();
  },
  methods: {
    formatDate,
    init() {
      getAccountView().then(res => {
        Object.assign(this.form, res.data);
        this.form.resourceList[0].imageUrl = res.data.socialCreditUrl || '';
        this.form.resourceList[1].imageUrl = res.data.idCardBack || '';
        this.form.resourceList[2].imageUrl = res.data.idCardFront || '';
        this.form.resourceList[3].imageUrl = res.data.bankAcctUrl || '';

        if (this.form.legalMp) {
          this.form.phone = this.form.legalMp.substring(
            this.form.legalMp.length - 11,
            this.form.legalMp.length,
          );
        }
        console.log(this.form.phone);
        this.form.legalCertId = res.data.legalCertId || '';
        this.form.legalPerson = res.data.legalPerson || '';
        this.form.corpName = res.data.corpName || '';
        this.form.bankAreacode = [res.data.bankProv, res.data.bankArea];
        this.loadBankList();
        this.getprovinceList(this.form.bankProv);
      });
    },
    loadBankList() {
      bankList().then(res => {
        // this.bankList = res.data.list;
        this.bankShowList = this.spliceArr(res.data.list);
        this.allBankList = Object.freeze(res.data.list);
        if (this.form.bankId) {
          this.bankShowList.map(v => {
            if (v.code == this.form.bankId) {
              this.bankName = v.name;
            }
          });
        }
      });
    },
    spliceArr(data) {
      let arr = [];
      data.map((v, index) => {
        if (this.form.bankId == v.code) {
          arr.push(v);
        } else if (index < 30) {
          arr.push(v);
        }
      });
      return arr;
    },
    openLiveUploadSuccess(response) {
      this.form.resourceList.forEach((item, index) => {
        if (response.category === item.category) {
          this.form.resourceList[index] = response;
        }
      });
      console.log(this.form.resourceList);
    },
    deleteOpenLiveUploadImage(response) {
      this.form.resourceList.forEach((item, index) => {
        if (response.category === item.category) {
          this.form.resourceList[index].imageUrl = '';
        }
      });
    },
    onSubmit() {
      Toast.loading({
        message: '开通中...',
        forbidClick: true,
        duration: 0,
      });
      let zipArr = [];
      if (this.form.phone.indexOf(' ') != -1) {
        this.form.phone = this.form.phone.split(' ')[1];
      }

      this.form.socialCreditUrl = this.form.resourceList[0].imageUrl;
      this.form.idCardBack = this.form.resourceList[1].imageUrl;
      this.form.idCardFront = this.form.resourceList[2].imageUrl;
      this.form.bankAcctUrl = this.form.resourceList[3].imageUrl;

      this.form.bankAcctName = this.form.corpName;
      this.form.legalCertIdExpires = this.form.legalCertIdExpires.replace(/-/g, '');
      this.form.socialCreditCodeExpires = this.form.socialCreditCodeExpires.replace(/-/g, '');
      this.form.bankProv = this.form.bankAreacode[0];
      this.form.bankArea = this.form.bankAreacode[1];
      this.form.shopType = '1';
      this.form.resourceList.map(v => {
        zipArr.push(v.imageUrl);
      });
      console.log(zipArr);
      createzip(zipArr)
        .then(res => {
          this.form.attachFile = res;
          console.log(res);
          return getQiniuInfos(res + '?qhash/sha1');
        })
        .then(qninfos => {
          if (qninfos.data.fsize / 1024 / 1024 > 4) {
            Toast('每个图片大小不能超过 1MB,请重新上传');
            return;
          } else {
            this.status == -1 ? this.add(this.form) : this.edit(this.form);
          }
        });

      console.log(this.form);
      // this.$emit('nextStep', this.form);
    },
    add(param) {
      accountCreate(param)
        .then(() => {
          Toast.clear(false);
          this.$router.go(-1);
        })
        .catch(err => {
          Toast.clear(false);
        });
    },
    edit(param) {
      accountUpdate(param)
        .then(() => {
          Toast.clear(false);
          this.$router.go(-1);
        })
        .catch(err => {
          Toast.clear(false);
        });
    },
    onCancelBank() {
      this.showBankList = false;
    },
    onConfirmBank() {
      let values = this.$refs.bankPick.getValues();
      if (values && values.length > 0) {
        const pick = values[0];
        this.showBankList = false;
        this.bankName = pick.name;
        this.form.bankId = pick.code;
      } else {
        Toast('请选择数据');
      }
    },
    onBankSearch(value) {
      if (value) {
        this.bankShowList = this.allBankList.filter(item => {
          return item.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
        this.$forceUpdate();
      } else {
        this.bankShowList = this.spliceArr(this.allBankList);
        this.$forceUpdate();
      }
    },

    onBankSearchCancel() {
      this.bankShowList = this.spliceArr(this.allBankList);
      this.$forceUpdate();
    },
    getprovinceList(bankProv = '') {
      provinceList().then(res => {
        console.log(res);
        this.areaList[0].values = res.data.list;
        if (bankProv) {
          let bankProvName;
          res.data.list.map(v => {
            if (v.code == bankProv) {
              bankProvName = v.name;
            }
          });
          this.getcity(bankProv, bankProvName);
        } else {
          this.getcity(res.data.list[0].code);
        }
      });
    },
    areaSelectChanged(pick, value, index) {
      if (index === 0) {
        const province = value[0];
        if (province && province.code) {
          this.getcity(province.code);
        }
      }
    },
    getcity(code, bankProvName) {
      cityList({ pCode: code }).then(res => {
        console.log(res);
        this.areaList[1].values = res.data.list;
        if (bankProvName) {
          this.showAreaText = `${bankProvName}/${res.data.list[0].name}`;
        }
        console.log(this.showAreaText);
      });
    },
    onAreaConfirm(pick, value) {
      this.showAddressList = false;
      if (pick[0].name && pick[1].name) {
        this.showAreaText = `${pick[0].name}/${pick[1].name}`;
        this.form.bankAreacode = [pick[0].code, pick[1].code];
      } else {
        this.showAreaText = null;
        this.form.bankAreacode = [];
        this.form.bankProv = null;
        this.form.bankArea = null;
      }
    },
    showTime(value) {
      this.isShowTime = value;
      this.showPickerDatetime = true;
    },
    onInput(value) {
      let date = formatDate(value);
      let arr = ['socialCreditCodeExpires', 'legalCertIdExpires'];
      // this.form.legalCertIdExpires = date;
      this.form[arr[this.isShowTime]] = date;
      this.showPickerDatetime = false;
    },
    changelegeTime(value) {
      if (value) {
        this.legalEnterpriseRegion = true;
        this.form.legalCertIdExpires = '永久';
      } else {
        this.legalEnterpriseRegion = false;
        this.form.legalCertIdExpires = '';
      }
    },
    changeTime(value) {
      if (value) {
        this.socialEnterpriseRegion = true;
        this.form.socialCreditCodeExpires = '永久';
      } else {
        this.socialEnterpriseRegion = false;
        this.form.socialCreditCodeExpires = '';
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url('~@/assets/css/liveShopCommon.less');
.form-info {
  background: white;
}

.company-type-tip {
  font-size: 12px;
  color: #cccccc;
  height: 30px;
  width: 100%;
  padding: 0 16px;
}
.account-open-container {
  padding-top: 10px;
  width: 100%;
  position: relative;
  min-height: 100vh;
  .form-bottom-line {
    font-weight: bold;
  }
  .tip {
    color: #999;
    font-size: 13px;
    margin: 10px;
  }
  .top-tool-bar {
    width: 100%;
    height: 44px;
    line-height: 44px;
    display: flex;
    justify-content: space-between;

    .cancel {
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: #969799;
    }
    .confirm {
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: #576b95;
    }
  }
}
.open-buttons {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  height: 58px;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: content-box;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  font-size: 14px;
  text-align: center;
  .left {
    flex: 1;
    height: 44px;
    line-height: 44px;
    color: #222222;
    border: 1px solid #222222;
    border-radius: 4px;
    background: white;
  }
  .right {
    flex: 1;
    height: 44px;
    line-height: 44px;
    color: white;
    background-color: #222222;
    margin-left: 15px;
    border-radius: 4px;
  }
}
/deep/ .van-field__control {
  font-size: 12px;
}
</style>
